import * as React from 'react'
const CheckBoxIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19.51 22h-15a2.45 2.45 0 01-1-.19 2.3 2.3 0 01-.81-.54 2.6 2.6 0 01-.55-.8 2.65 2.65 0 01-.19-1v-15a2.45 2.45 0 01.19-1 2.3 2.3 0 01.54-.81 2.6 2.6 0 01.8-.55 2.65 2.65 0 011-.19h15a2.45 2.45 0 011 .19 2.3 2.3 0 01.81.54 2.6 2.6 0 01.55.8 2.65 2.65 0 01.19 1v15a2.45 2.45 0 01-.19 1 2.3 2.3 0 01-.54.81 2.6 2.6 0 01-.8.55 2.65 2.65 0 01-1 .19zM4.49 3A1.5 1.5 0 003 4.49v15a1.46 1.46 0 00.11.58 1.43 1.43 0 00.32.49 1.34 1.34 0 00.49.32 1.39 1.39 0 00.57.12h15a1.46 1.46 0 00.58-.11 1.43 1.43 0 00.49-.32 1.34 1.34 0 00.32-.49 1.39 1.39 0 00.12-.57v-15a1.46 1.46 0 00-.11-.58 1.43 1.43 0 00-.32-.49 1.34 1.34 0 00-.49-.32 1.39 1.39 0 00-.57-.12z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default CheckBoxIcon